import { render, staticRenderFns } from "./AdyGooglePay.vue?vue&type=template&id=6f99bd10&scoped=true"
import script from "./AdyGooglePay.vue?vue&type=script&lang=js"
export * from "./AdyGooglePay.vue?vue&type=script&lang=js"
import style0 from "./AdyGooglePay.vue?vue&type=style&index=0&id=6f99bd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99bd10",
  null
  
)

export default component.exports